<template>
    <v-btn id="rotate-media-button"
           ref="rotate-media-button"
           v-tippy
           content="Rotate Image"
           :disabled="isDisabled"
           @click="onClick"
    >

        <v-icon class="material-icons">rotate_right</v-icon>
    </v-btn>

</template>

<script>
import { mapState } from "vuex";

export default {
    mounted() {
        this.$root.$refs.rotateMediaButton = this.$refs['rotate-media-button'];
    },

    computed: {
        ...mapState('Projects', ['image']),
        isDisabled() {
            return !this.image;
        }
    },

    methods: {
        onClick() {
            if (this.isDisabled) return;
            window.UI.rotateScene();
        }
    }
}
</script>